// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4b178b48","732":"7802454d"}[chunkId] + ".chunk.js";
};